<template>
  <div>
    <FixedButton>
      <el-button
        type="primary"
        plain
        @click="handleExport"
        v-loading.fullscreen.lock="fullLoading"
        element-loading-text="正在导出..."
        >导出</el-button
      >
      <el-button
        type="primary"
        plain
        @click.stop="handleOpen"
        size="small"
        :disabled="selectList.length === 0"
        >远程启停</el-button
      >
      <el-button
        type="primary"
        @click.stop="handleSet"
        size="small"
        :disabled="selectList.length === 0"
        >参数设置</el-button
      >
    </FixedButton>
    <CardContainer>
      <CommonForm slot="header" @search="formSearch" :form-json="formjson" />
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        :needIndex="true"
        :needSelection="true"
        @select="handleSelect"
        @change="handleTableChange"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
      >
      </CommonTable>
    </CardContainer>
    <Param
      v-if="visibleParam"
      :visible.sync="visibleParam"
      :detail="false"
      :ids="ids"
      :assetId="assetId"
    />
    <Open
      v-if="visibleOpen"
      :visible.sync="visibleOpen"
      :detail="false"
      :ids="ids"
      :assetId="assetId"
    />
  </div>
</template>

<script>
import formjson from './Model/Formjson.List'
import tablejson from './Model/Tablejson.List'
import formTableMixin from '@kaili/mixins/formTableMixin'
import { downloadFile } from '@kaili/utils/download'
import Param from './param'
import Open from './open'
export default {
  mixins: [formTableMixin],
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: '详情',
          type: 'detail'
        },
        {
          name: '解绑',
          type: 'delete',
          hide(row) {
            return !row.shopId
          }
        },
        {
          name: '定位',
          type: 'map',
          hide(row) {
            return !row.latitude || !row.longitude
          }
        }
      ],
      visibleParam: false,
      visibleOpen: false,
      row: {},
      selectList: [],
      ids: '',
      assetId: '',
      queryApi: this.$api.freezer.device_list,
      deleteApi: this.$api.freezer.device_delete,
      exportApi: this.$api.freezer.device_export
    }
  },
  computed: {
    fullLoading() {
      return this.$store.state.fullLoading
    }
  },
  components: {
    Param,
    Open
  },
  methods: {
    formSearch(data) {
      let params = { ...data }
      if (params.typeNumber) {
        if (params.typeNumber.length === 1) {
          params.modelName = params.typeNumber[0]
        }
        if (params.typeNumber.length === 2) {
          params.modelName = params.typeNumber[0]
          params.assetId = params.typeNumber[1]
        }
        delete params.typeNumber
      }

      this.search(params, null, this.queryApi)
    },
    handleSelect(selection) {
      this.selectList = selection.map((item) => {
        return item
      })
    },
    handleExport() {
      this.$confirm('确认导出?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.commit('SET_FULL_LOADING', true)
          let params = {
            ...this.cacheData
          }
          if (params.typeNumber) {
            if (params.typeNumber.length === 1) {
              params.modelName = params.typeNumber[0]
            }
            if (params.typeNumber.length === 2) {
              params.modelName = params.typeNumber[0]
              params.assetId = params.typeNumber[1]
            }
            delete params.typeNumber
          }
          this.$ajax.download(this.exportApi, params).then((res) => {
            this.$store.commit('SET_FULL_LOADING', false)
            downloadFile(res)
          })
        })
        .catch(() => {})
    },
    handleSet() {
      for (let i = 0; i < this.selectList.length; i++) {
        for (let j = i + 1; j < this.selectList.length; j++) {
          if (this.selectList[i].assetId !== this.selectList[j].assetId) {
            this.$message.error('设备型号不一致不允许批量设置参数')
            return false
          }
        }
      }
      for (let i = 0; i < this.selectList.length; i++) {
        if (this.selectList[i].online === 'offline') {
          this.$message.error('离线设备不允许批量设置参数')
          return false
        }
      }
      let ids = []
      this.selectList.map((item) => {
        ids.push(item.id)
        this.assetId = item.assetId
      })
      this.ids = ids.join()
      this.visibleParam = true
    },
    handleOpen() {
      for (let i = 0; i < this.selectList.length; i++) {
        for (let j = i + 1; j < this.selectList.length; j++) {
          if (this.selectList[i].assetId !== this.selectList[j].assetId) {
            this.$message.error('设备型号不一致不允许批量远程启停')
            return false
          }
        }
      }
      for (let i = 0; i < this.selectList.length; i++) {
        if (this.selectList[i].online === 'offline') {
          this.$message.error('离线设备不允许批量远程启停')
          return false
        }
      }
      let ids = []
      this.selectList.map((item) => {
        ids.push(item.id)
        this.assetId = item.assetId
      })
      this.ids = ids.join()
      this.visibleOpen = true
    },
    handleDetail(row) {
      this.$router.push(
        '/freezer/list/detail?id=' +
          row.id +
          '&assetNumber=' +
          row.assetNumber +
          '&room=' +
          row.room +
          '&assetId=' +
          row.assetId
      )
    },
    handleMap(row) {
      this.$router.push('/freezer/map?assetNumber=' + row.assetNumber)
    },
    handleDelete(row) {
      this.$confirm('确认将该设备与门店解绑吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            assetNumber: row.assetNumber
          }
          this.$ajax
            .post(this.$api.freezer.device_unbinding, params)
            .then(() => {
              this.$message.success('解绑成功')
              this.formSearch(this.cacheData)
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'detail':
          this.handleDetail(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        case 'map':
          this.handleMap(row)
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.myBtn {
  margin-right: 10px;
}
.el-table {
  .system-defined {
    background: #f0f9eb;
  }
}
</style>
